var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M5,2A3,3,0,0,0,2,5V19a3,3,0,0,0,3,3h7.392A7,7,0,0,1,18,9.29V5a3,3,0,0,0-3-3ZM5,6A1,1,0,0,1,6,5h6a1,1,0,0,1,0,2H6A1,1,0,0,1,5,6Zm1,5a1,1,0,0,0,0,2H8a1,1,0,0,0,0-2ZM5,9A1,1,0,0,1,6,8h4a1,1,0,0,1,0,2H6A1,1,0,0,1,5,9Z",
    fill: "#e66",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm2.322,7.092A1,1,0,0,0,17,15.6V14a1,1,0,0,0-2,0v1.6a1,1,0,0,0-1.322,1.5l1.615,1.615a1,1,0,0,0,1.414,0Z",
    fill: "#e66",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceDownloadIcon);
export default __webpack_public_path__ + "static/media/invoice_download_icon.d4026dee00c5b287e050cdc8f8d210e0.svg";
export { ForwardRef as ReactComponent };